export const reportsEINPaymentConstants = {
  GET_REPORTS_EIN_PAYMENT_REQUEST: "GET_REPORTS_EIN_PAYMENT_REQUEST",
  GET_REPORTS_EIN_PAYMENT_SUCCESS: "GET_REPORTS_EIN_PAYMENT_SUCCESS",
  GET_REPORTS_EIN_PAYMENT_FAILURE: "GET_REPORTS_EIN_PAYMENT_FAILURE",
};
